export default {
  header: 'Contact',
  lead: 'Questions? Feel free to reach out to me here:',
  phone: '206.778.6668',
  email: 'kevinleroy@live.com'
};
